import { api } from '../api';

// ========== TYPES ==========

export interface RouletteProduct {
  id: number;
  name: string;
  price: number;
  image_url: string;
  weight?: string;
  description?: string;
  sku?: string;
  drop_weight?: number; // Вес выпадения (1-100), только для админки
}

export interface RouletteConfig {
  is_active: boolean;
  price: number;
  products: RouletteProduct[];
}

export interface SpinResult {
  spin_id: string;
  winner: RouletteProduct;
  belt_sequence: number[];
  winner_index: number;
}

// ========== API FUNCTIONS ==========

/**
 * Get roulette configuration (public)
 */
export async function getRouletteConfig(): Promise<RouletteConfig> {
  const response = await api.get<RouletteConfig>('/roulette/config');
  return response.data;
}

/**
 * Get IDs всех продуктов, которые сейчас активны в рулетке.
 * Используется для ревалидации корзины: если в localStorage остался
 * рулеточный товар из старой акции, и его уже нет в этом списке —
 * корзина удаляет его и показывает тост.
 */
export async function getActiveRouletteProducts(): Promise<number[]> {
  const response = await api.get<{ product_ids: number[] }>('/roulette/active-products');
  return response.data.product_ids || [];
}

/**
 * Spin the roulette (server-side randomization)
 */
// cartProductIds — id товаров корзины. Сервер по ним проверяет, нет ли в корзине
// «Сета дня»: он не суммируется с рулеткой, и крутить в этом случае нельзя —
// иначе человек выиграет приз, который потом не применить к заказу.
export async function spinRoulette(cartProductIds: number[] = []): Promise<SpinResult> {
  const response = await api.post<SpinResult>('/roulette/spin', { cartProductIds });
  return response.data;
}
